






import Vue from 'vue';

import OrganizationLoadGuard from '@/components/OrganizationLoadGuard.vue';
import OrganizationSettings from '@/views/authenticated/OrganizationSettings.vue';

export default Vue.extend({
  components: {
    OrganizationLoadGuard,
    OrganizationSettings
  },

  props: {
    organizationId: Number
  }
});
